import { Button } from 'components/Button/Button'
import { IconWarning } from 'components/icons/IconWarning'
import { translate } from 'i18n/i18n'
import { colors } from 'settings/colors'
import { detailsPanelStore } from 'stores/detailsPanelStore/detailsPanelStore'
import { unitConverter } from 'utils/unitConverter/unitConverter'

type TFlowMeterChartLegend = {
  maxFlowRateGpm: number | null
  minFlowRateGpm: number | null
}

const DotLineIcon = () => {
  const colorStyles = {
    height: 2,
    width: 4,
    display: 'inline-block',
    background: colors.darkOrange,
  }

  return (
    <div css={{ display: 'flex', alignItems: 'center', margin: '0px 4px 0px 10px', gap: 3 }}>
      <span css={colorStyles} />
      <span css={colorStyles} />
    </div>
  )
}

export const FlowMeterChartLegend = ({ maxFlowRateGpm, minFlowRateGpm }: TFlowMeterChartLegend) => {
  if (!maxFlowRateGpm && !minFlowRateGpm)
    return (
      <div css={{ flex: 1, display: 'flex', margin: '10px 10px 15px 50px' }}>
        <div css={{ color: colors.yellow, marginRight: 5 }}>
          <IconWarning />
        </div>
        <div css={{ fontSize: 14, color: colors.grey900 }}>
          <translate.Phrases.banyanApp
            k="Limits not set, click <HereLink>here</HereLink> to configure"
            c={{
              HereLink: (
                <Button
                  variant="link"
                  css={{
                    fontSize: 14,
                    marginTop: -7,
                    padding: 0,
                  }}
                  onClick={() => {
                    detailsPanelStore.setState((s) => ({
                      ...s,
                      flowMeterLimitsSettingsOpened: true,
                    }))
                  }}
                />
              ),
            }}
          />
        </div>
      </div>
    )

  return (
    <div css={{ flex: 1 }}>
      <div css={{ display: 'flex', margin: '10px 10px 15px', fontSize: 14, color: colors.grey900 }}>
        {maxFlowRateGpm && (
          <div css={{ display: 'flex', alignItems: 'center', paddingRight: '10px' }}>
            <DotLineIcon />
            <span>
              {`${translate.phrases.banyanApp('Max Flow Rate')}: ${unitConverter
                .flowRate(maxFlowRateGpm)
                .valueWithSuffix()}`}
            </span>
          </div>
        )}
        {minFlowRateGpm && (
          <div css={{ display: 'flex', alignItems: 'center', paddingRight: '10px' }}>
            <DotLineIcon />
            <span>
              {`${translate.phrases.banyanApp('Min Flow Rate')}: ${unitConverter
                .flowRate(minFlowRateGpm)
                .valueWithSuffix()}`}
            </span>
          </div>
        )}
      </div>
    </div>
  )
}
